import './index.scss'
import AnimatedLetters from '../AnimatedLetters'
import { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHouse, faUser, faEnvelope, faUserPlus, faCode, faAnchor } from '@fortawesome/free-solid-svg-icons'

const About = () => {
    const [letterClass, setLetterClass] = useState('text-animate')
    useEffect(() => {
        setTimeout(() => {
          setLetterClass('text-animate-hover')
        }, 3000)
      }, [])


    return (
        <div className='container about-page'>
            <div className='text-zone'>
                <h1>
                    <AnimatedLetters
                    letterClass={letterClass}
                    strArray={['A','b','o','u','t']}
                    idx={15}
                    />
                </h1>
	    <div className="about-content">
                <p className="paragraph">
	    Founded on November 1, 2024, in the heart of Texas, Triple Point Analytics is dedicated to transforming how businesses harness the power of data. Specializing in data engineering, machine learning, and analytics services, our company is committed to delivering cutting-edge solutions that prioritize automation, metrics, and inference.

          </p>
          <p align="LEFT" className="paragraph">
	    At Triple Point Analytics, we understand that the world of data is ever-evolving, which is why we cater to a wide spectrum of data needs—whether you’re dealing with megabytes or exascale datasets. Our expert team excels in constructing robust data pipelines that seamlessly handle both streaming and batching processes across on-premise and cloud environments.
          </p>
          <p className="paragraph">
	    Our vision is simple yet profound: to provide solutions that enable our clients to monitor their data operations effortlessly, ensuring that even the most complex challenges can be addressed from a mobile device. With Triple Point Analytics, you can rest assured that regardless of the complexity or simplicity of your data needs, we have the right solution tailored for you. Embrace the future of analytics with us, where your data insights are just a click away.
          </p>
           </div> 
            </div>


            <div className='stage-cube-cont'>
                <div className='cubespinner'>
                    <div className='face1'>
                        <FontAwesomeIcon icon={faHouse} color="#DD0031" />
                    </div>
                    <div className='face2'>
                        <FontAwesomeIcon icon={faUser} color="#F06529" />
                    </div>
                    <div className='face3'>
                        <FontAwesomeIcon icon={faEnvelope} color="#28A4D9" />
                    </div>
                    <div className='face4'>
                        <FontAwesomeIcon icon={faUserPlus} color="#5ED4F4" />
                    </div>
                    <div className='face5'>
                        <FontAwesomeIcon icon={faCode} color="#EFD81D" />
                    </div>
                    <div className='face6'>
                        <FontAwesomeIcon icon={faAnchor} color="#EC4D28" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default About
